/*
 * Module for the response-related KB settings (touchPoints, locales, and contexts)
 */

define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "./responseSettingsView",
  "modules/accountAdmin/kbWizardModal/kbWizardModalModule",
], function (Backbone, Marionette, Messenger, ResponseSettingsView, KbWizardModalModule) {
  var ResponseSettingsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "responseSettings";
      this.region = options.region;
      this.kb = options.model;
      this._setUpVents();
    },
    show: function () {
      this.kb.touchPoints = this.kb.getTouchPoints();
      this.kb.locales = this.kb.getLocales();
      this.kb.contexts = this.kb.getContexts();

      Messenger.onSave(function () {
        Messenger.saveAttempted(true); //success
      }, this);

      this.layout = new ResponseSettingsView.responseSettingsLayout({ model: this.kb });

      this.kb.touchPoints.onSynced(function () {
        this.kb.locales.onSynced(function () {
          this.kb.contexts.onSynced(function () {
            this.showRegion(this.layout);
          }, this);
        }, this);
      }, this);

      this.layout.on(
        "edit:contexts",
        function () {
          var modalBundle = {
            kbStep: "contexts",
            item: this.kb,
          };
          Messenger.vent.trigger(
            "show:modal",
            KbWizardModalModule,
            {
              editMode: true,
            },
            modalBundle,
            {
              title: "admin.kbAdmin.editKb",
              closeOnBackgroundClick: false,
              modalWidth: 1000,
              trackInteraction: {
                action: "Edit Knowledge Base",
                id: this.kb.id,
                idType: "Knowledge Base",
                object: "Knowledge Base",
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "edit:locales",
        function () {
          var modalBundle = {
            kbStep: "locales",
            item: this.kb,
          };
          Messenger.vent.trigger(
            "show:modal",
            KbWizardModalModule,
            {
              editMode: true,
            },
            modalBundle,
            {
              title: "admin.kbAdmin.editKb",
              closeOnBackgroundClick: false,
              modalWidth: 1000,
              trackInteraction: {
                action: "Edit Knowledge Base",
                id: this.kb.id,
                idType: "Knowledge Base",
                object: "Knowledge Base",
              },
            },
          );
        },
        this,
      );

      this.layout.on(
        "edit:touchPoints",
        function () {
          var modalBundle = {
            kbStep: "touchPoints",
            item: this.kb,
          };
          Messenger.vent.trigger(
            "show:modal",
            KbWizardModalModule,
            {
              editMode: true,
            },
            modalBundle,
            {
              title: "admin.kbAdmin.editKb",
              closeOnBackgroundClick: false,
              modalWidth: 1000,
              trackInteraction: {
                action: "Edit Knowledge Base",
                id: this.kb.id,
                idType: "Knowledge Base",
                object: "Knowledge Base",
              },
            },
          );
        },
        this,
      );
    },
    _setUpVents: function () {
      //Show the response settings screen
      Messenger.vent.on(
        "show:kb:profile:responseSettings",
        function () {
          this.show();
        },
        this,
      );

      Messenger.vent.on(
        "refresh:kb:response:settings",
        function (updatedKb) {
          this.kb = updatedKb;
          this.show();
        },
        this,
      );
    },
  });

  return ResponseSettingsController;
});
